import { render } from "./InspectionAreaDetails.vue?vue&type=template&id=54e4000a&scoped=true"
import script from "./InspectionAreaDetails.vue?vue&type=script&lang=js"
export * from "./InspectionAreaDetails.vue?vue&type=script&lang=js"

import "./InspectionAreaDetails.vue?vue&type=style&index=0&id=54e4000a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e4000a"]])

export default __exports__